import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';

import { translate } from 'services/i18nService';

import IconTokens from '../../../../../images/profilePage/tokens-grey.png';

import styles from './QuickGift.css';


const DAYS_TO_DISPLAY_NEW_TAG = 7;

const QuickGift = (props) => {
  const { name, ttKey, details, price, onClickHandler, isDesktop, releaseDate } = props;
  const imageUrl = details?.imageUrl;

  const newTagElement = useMemo(() => {
    const isNewGift = moment().diff(moment(releaseDate), 'days') <= DAYS_TO_DISPLAY_NEW_TAG;

    if (isNewGift) {
      return (
        <div className={styles.newTag}>
          {translate('v2profile.gifts.marketplace.new')}
        </div>
      );
    }

    return null;
  }, [releaseDate]);

  const onClickSendGift = useCallback(() => {
    onClickHandler(props);
  }, [onClickHandler, props]);

  const wrapperClass = classNames({
    [styles.giftWrapperDesktop]: isDesktop,
    [styles.giftWrapperMobile]: !isDesktop,
  });

  return (
    <div className={wrapperClass}>
      <div className={styles.GiftContainer} onClick={onClickSendGift}>
        {newTagElement}
        <img
          alt={name}
          className={styles.giftImage}
          src={imageUrl}
        />
        <div className={styles.details}>
          <div className={styles.name}>
            {translate(`gifting.${ttKey}`, {}, name)}
          </div>
          <div className={styles.price}>
            <img
              alt="tokens icon"
              className={styles.img}
              src={IconTokens}
            />
            <span className={styles.priceText}>
              {price}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

QuickGift.propTypes = {
  name: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  releaseDate: PropTypes.string.isRequired,
  details: PropTypes.object,
  isDesktop: PropTypes.bool,
  ttKey: PropTypes.string,
  onClickHandler: PropTypes.func,
};

QuickGift.defaultProps = {
  details: undefined,
  isDesktop: false,
  ttKey: undefined,
  onClickHandler: () => undefined,
};

export default QuickGift;
